import React from 'react';

import { usePathname } from 'next/navigation';

import { SignUpModalAction } from './DownloadAppModal';
import styles from './styles.module.css';

import { DownloadAppButton } from '@/components/DownloadAppButton';
import { DownloadAppQRCodeSection } from '@/components/DownloadAppQRCodeSection';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { getRouteName } from '@/modules/activityTracker/referers';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { DeviceType } from '@/modules/device/types';
import { useUserAgent } from '@/modules/device/useUserAgent';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  downloadAppTrackingId: string;
};

export function AppDownloadSection({ downloadAppTrackingId }: Props) {
  const [isAuthenticated, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });
  const { device } = useUserAgent();
  const pathname = usePathname();

  const isAndroid = device === DeviceType.ANDROID;

  function sendSignupModalActionEvent(actionType: SignUpModalAction) {
    const pageType = getRouteName(pathname);
    sendActivityTrackerEvent(ActivityTrackerEventType.SIGNUP_MODAL_ACTION, {
      pageType,
      actionType,
      schemaVersion: '1.0',
    });
  }

  return (
    <div className={styles.appDownloadContainer}>
      <div className={styles.downloadButtonContainer}>
        <DownloadAppButton
          outline={!isAuthenticated}
          trackingId={downloadAppTrackingId}
          onClick={() =>
            sendSignupModalActionEvent(
              isAndroid
                ? SignUpModalAction.PLAY_STORE
                : SignUpModalAction.APP_STORE
            )
          }
          block
        />
      </div>
      <DownloadAppQRCodeSection
        placement="signup_modal"
        sourceId={downloadAppTrackingId}
      />
    </div>
  );
}
